// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import MButton from '../../../../../components/MButton';
import Colours from '../../../../../styles/colours';
import { getDynamicPolygonClipPath } from '../../../../../common/util';

const BoundingBox = ({ item, onClick, selectionMode, inputs, imageSize, onMouseOver, onMouseOut }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <MButton
      key={item.text}
      onClick={onClick}
      className="w-100 h-100 position-absolute"
      colour={inputs[selectionMode].includes(item.line) ? Colours.Green : Colours.LightGray}
      style={{
        borderRadius: 0,
        opacity:      isHovered ? 0.5 : 0.3,
        clipPath:     getDynamicPolygonClipPath(item.coords, imageSize),
      }}
      onMouseOver={() => {
        setIsHovered(true);
        onMouseOver();
      }}
      onMouseOut={() => {
        setIsHovered(false);
        onMouseOut();
      }}
      text=""
    />
  );
};

BoundingBox.propTypes = {
  item: PropTypes.shape({
    text:   PropTypes.string.isRequired,
    line:   PropTypes.number.isRequired,
    coords: PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  }).isRequired,
  onClick:       PropTypes.func.isRequired,
  selectionMode: PropTypes.string.isRequired,
  inputs:        PropTypes.shape(Object).isRequired,
  imageSize:     PropTypes.shape({
    width:  PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut:  PropTypes.func.isRequired,
};

export default BoundingBox;
